import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import AnswerDisplay from './AnswerDisplay';
import Chat from './Chat';
import ChatWithAgentButton from './ChatWithAgentButton';
import CSSTransitionOnMount from 'presentation/components/lib/CSSTransitionOnMount';
import { getCurrentLocation, getSelfService } from 'app/modules';
import getRadius from 'lib/getRadius';
import Header from 'presentation/selfService/Header';
import { isAlternateBucket } from 'lib/handleBucketLogic';
import isMobileWidth from 'lib/isMobileWidth';
import uiEnums from 'enums/ui';
import OfficeHourDisplay from './OfficeHourDisplay';
import overrideStyle from 'lib/overrideStyle';
import Search from 'presentation/selfService/Search';
import QuickActions from './QuickActions';

export function SelfService(props) {
  const { quickActions } = props.selfServiceCustomization;

  let content;
  let shouldDisplayTitle = true;
  let shouldDisplayBackButton = true;
  let shouldDisplayChatButton = true;
  let isChatting = false;

  if (props.currentLocation === uiEnums.LOCATIONS.OFFICE_HOURS) {
    content = <OfficeHourDisplay />;
    shouldDisplayChatButton = false;
    shouldDisplayTitle = false;
  } else if (props.currentLocation === uiEnums.LOCATIONS.ANSWER) {
    content = <AnswerDisplay />;
    shouldDisplayTitle = false;
  } else if (props.isABTestingOnboarding || props.currentLocation === uiEnums.LOCATIONS.CHAT) {
    content = <Chat />;
    shouldDisplayChatButton = false;
    isChatting = true;
  } else {
    content = <Search defaultContent={<QuickActions quickActions={quickActions} />} />;
    shouldDisplayBackButton = false;
  }

  return (
    <CSSTransitionOnMount className="fadeSelfServiceUp" timeout={500}>
      <Wrapper data-aid="selfService-wrapper" isMobileWidth={isMobileWidth()}>
        <HeaderWrapper>
          <Header
            shouldDisplayBackButton={shouldDisplayBackButton}
            shouldDisplayTitle={shouldDisplayTitle}
            isChatting={isChatting}
          />
          {content}
        </HeaderWrapper>
        {shouldDisplayChatButton ? <ChatWithAgentButton /> : null}
      </Wrapper>
    </CSSTransitionOnMount>
  );
}

const HeaderWrapper = overrideStyle('div')`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const Wrapper = overrideStyle('div')`
  background-color: white;
  border-color: ${p => p.theme.border.color};
  border-radius: ${p => (p.isMobileWidth || p.theme.isMobileSdk ? '0' : getRadius(p.theme.borderRadius, 8, 16))};
  border-style: ${p => (p.theme.border.color ? 'solid' : 'none')};
  border-width: ${p => p.theme.border.width};
  box-shadow: ${p => (p.theme.dropshadowEnabled ? '0 0 30px 1px rgba(0, 0, 0, 0.2)' : 'none')};
  display: flex;
  flex-direction: column;
  height: ${p => (p.theme.isMobileSdk ? '100vh' : '577px')};
  margin: ${p => (p.theme.isMobileSdk ? '0' : 'inherit')};
  max-height: ${p => (p.theme.isMobileSdk ? '100vh' : 'calc(100vh - 30px)')};
  justify-content: flex-end;
  opacity: 0;
  overflow: hidden;
  top: 0px;
  transform: translateY(140px);
  width: ${p => (p.theme.isMobileSdk ? '100vw' : '364px')};

  &.fadeSelfServiceUp-enter-active {
    opacity: 1;
    transition: ${p =>
      p.theme.isMobileSdk ? 'none' : 'opacity 450ms cubic-bezier(0.42, 0, 1, 1), transform 500ms ease'};
    transform: translateY(0);
  }
  &.fadeSelfServiceUp-enter-done {
    opacity: 1;
    transform: translateY(0);
  }

  @media (max-width: 667px) {
    bottom: 0;
    height: 100vh;
    overflow: visible;
    width: 100vw;
  }
`;

SelfService.propTypes = {
  currentLocation: PropTypes.string,
  isABTestingOnboarding: PropTypes.bool.isRequired,
  selfServiceCustomization: PropTypes.object,
};

export const mapStateToProps = state => {
  return {
    currentLocation: getCurrentLocation(state),
    isABTestingOnboarding: isAlternateBucket(state.configuration.onboardingTypeTestBucket),
    selfServiceCustomization: getSelfService(state),
  };
};

export default connect(mapStateToProps)(SelfService);
